var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c(
            "van-pull-refresh",
            {
              staticClass: "refreshBox",
              class: { returnListBox: !_vm.listShow },
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.isLoading,
                callback: function($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading"
              }
            },
            [
              _c(
                "van-list",
                {
                  attrs: { finished: _vm.finished },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.ploading,
                    callback: function($$v) {
                      _vm.ploading = $$v
                    },
                    expression: "ploading"
                  }
                },
                _vm._l(_vm.dataList, function(item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "returnList" },
                    [
                      _c(
                        "van-card",
                        {
                          attrs: {
                            title: item.productName,
                            thumb: item.productImg
                          }
                        },
                        [
                          _c("template", { slot: "desc" }, [
                            _c("p", { staticClass: "descP" }, [
                              _vm._v(_vm._s(item.specificationValue))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "numP" }, [
                              _c("span", [_vm._v("×" + _vm._s(item.quantity))])
                            ])
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "returnType" }, [
                        _c("p", [
                          _c("img", { attrs: { src: _vm.refundUrl, alt: "" } }),
                          _vm._v(" "),
                          _c("span", { staticClass: "spanType" }, [
                            _vm._v(_vm._s(item.typeStr))
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.statusStr))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btnStyle" },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: { round: "" },
                              on: {
                                click: function($event) {
                                  _vm.openGoodDetails(item)
                                }
                              }
                            },
                            [_vm._v("查看详情")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              !_vm.listShow
                ? _c("div", { staticClass: "noListStyle" }, [
                    _c("img", { attrs: { src: _vm.noListUrl, alt: "" } }),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无订单！")])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }